export const getJourneyDurationInMinutes = (journeyLegs: any[]): number => {
  const trainLegs = journeyLegs.filter((leg: any) => !leg.walking);
  const originLeg = trainLegs[0] || journeyLegs[0];
  const destinationLeg = trainLegs[trainLegs.length - 1] || journeyLegs[journeyLegs.length - 1];

  if (!originLeg?.plannedDeparture || !destinationLeg?.plannedArrival) {
    return 0;
  }

  const duration = new Date(destinationLeg.plannedArrival).getTime() - new Date(originLeg.plannedDeparture).getTime()
  const durationInMinutes = duration/60000

  return durationInMinutes;
}

export const getDurationInMinutes = (departure: string, arrival: string) => {
  const duration = new Date(arrival).getTime() - new Date(departure).getTime()
  const durationInMinutes = duration/60000

  return durationInMinutes;
}

export const formatDuration = (durationInMinutes: number | null | undefined): string => {
  if (durationInMinutes === null || durationInMinutes === undefined) {
    return 'N/A';
  }
  
  const hours = Math.floor(durationInMinutes / 60);        
  const minutes = Math.round(durationInMinutes % 60);
  const minutesString = hours > 0 ? minutes.toString().padStart(2, '0') : minutes.toString();

  if (hours <= 0) return `${minutesString}m`
  return `${hours}h${minutesString}m`;
}
